import React, { useState, useEffect } from 'react';
import './MathsLab.css';

// Import images for Maths Lab
import mathslab1 from '../assets/mathlab.jpeg';

const MathsLab = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const mathslabImages = [mathslab1];

  useEffect(() => {
    setIsVisible(true);
    
    // Auto-slide images every 3 seconds
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === mathslabImages.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const handleDotClick = (index) => {
    setCurrentImageIndex(index);
  };

  const handlePrevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? mathslabImages.length - 1 : prevIndex - 1
    );
  };

  const handleNextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === mathslabImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="mathslab-container">
       {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>MATH</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>Math</li>
          </ul>
        </div>
      </section>

      {/* Main Content */}
      <div className="mathslab-main-content">
        <div className="mathslab-content-wrapper">
          {/* Left Side - Text Content */}
          <div className={`mathslab-text-content ${isVisible ? 'mathslab-visible' : ''}`}>
            <h2 className="mathslab-main-heading">MATHS LAB</h2>
            
            <p className="mathslab-intro-text">
              A child can perceive a concept thoroughly only with the combination of theoretical teaching in 
              a classroom and hands on experience in a lab. Maths needs practice, interest and brainpower 
              which are fostered by the Maths lab. The BCA Maths Lab makes maths simple and fun for students. 
              The lab is well equipped to demonstrate and elucidate any topic.
            </p>

            <p className="mathslab-section-text">
              For instance, the 'RAMANUJAN'S KIT' has all the components with which every important concept 
              and formula can be proved practically. It also enables the teachers to demonstrate and reinforce 
              Mathematical concepts. Hence, it helps in mental enhancement of students in any area of Maths 
              like Algebra, Arithmetic, Calculus, Geometry, Statistics, and Trigonometry etc.
            </p>

            <div className="mathslab-feature">
              <h3 className="mathslab-feature-title">Interactive Learning Tools:</h3>
              <p className="mathslab-feature-text">
                The lab is equipped with mathematical models, geometric instruments, measurement tools, and 
                manipulatives that help students visualize abstract mathematical concepts and make them tangible.
              </p>
            </div>

            <div className="mathslab-feature">
              <h3 className="mathslab-feature-title">Software Integration:</h3>
              <p className="mathslab-feature-text">
                Another software is the Metamouse which encourages Cooperative Learning and facilitates group 
                activities. Departmental library in the lab helps students to browse through the books on 
                various topics.
              </p>
            </div>
          </div>

          {/* Right Side - Image Slider */}
          <div className={`mathslab-image-slider ${isVisible ? 'mathslab-visible' : ''}`}>
            <div className="mathslab-slider-container">
              {mathslabImages.map((image, index) => (
                <img
                  key={index}
                  src={image}
                  alt={`Maths Lab ${index + 1}`}
                  className={`mathslab-slider-image ${
                    index === currentImageIndex ? 'mathslab-active' : ''
                  }`}
                />
              ))}
              
            </div>
          </div>
        </div>

        {/* Additional Features Section */}
        <div className={`mathslab-additional-section ${isVisible ? 'mathslab-visible' : ''}`}>
          <div className="mathslab-feature">
            <h3 className="mathslab-feature-title">Hands-On Activities:</h3>
            <p className="mathslab-feature-text">
              Students engage in practical activities that involve measuring, calculating, constructing 
              geometric shapes, and solving real-world mathematical problems. This experiential learning 
              approach makes mathematics more meaningful and applicable.
            </p>
          </div>

          <div className="mathslab-feature">
            <h3 className="mathslab-feature-title">Problem-Solving Skills:</h3>
            <p className="mathslab-feature-text">
              The lab environment encourages students to explore different problem-solving strategies, 
              develop logical thinking, and build confidence in their mathematical abilities through 
              collaborative projects and individual challenges.
            </p>
          </div>

          <div className="mathslab-feature">
            <h3 className="mathslab-feature-title">Mathematical Library:</h3>
            <p className="mathslab-feature-text">
              Our departmental library contains books on various mathematical topics, reference materials, 
              puzzle books, and mathematical journals that students can access to deepen their understanding 
              and explore advanced concepts.
            </p>
          </div>

          <p className="mathslab-conclusion-text">
            The Maths Lab at Bihani Children's Academy transforms mathematics from an abstract subject into 
            an engaging, practical, and enjoyable learning experience. Through hands-on activities and modern 
            teaching aids, we help students develop a strong foundation in mathematics and a lifelong love for 
            the subject.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MathsLab;